export var HistoryCurveRefreshCycleEnum;
(function (HistoryCurveRefreshCycleEnum) {
    HistoryCurveRefreshCycleEnum[HistoryCurveRefreshCycleEnum["ThirtyMinutes"] = 30] = "ThirtyMinutes";
    HistoryCurveRefreshCycleEnum[HistoryCurveRefreshCycleEnum["SixtyMinutes"] = 60] = "SixtyMinutes";
    HistoryCurveRefreshCycleEnum[HistoryCurveRefreshCycleEnum["OneHundredTwentyMinutes"] = 120] = "OneHundredTwentyMinutes";
})(HistoryCurveRefreshCycleEnum || (HistoryCurveRefreshCycleEnum = {}));
